<template>
  <div>
    <navigation/>
    <div class="main" style="margin-top: 29px;padding-top: 0px;">
      <div class="bs-contain clearfix">
        <div class="bs-left">
          <div class="query-form" style="margin-top: -50px">
            <p class="query-form-title">电子标识查询</p>
            <form method="post">
              <div class="input">
                <label>网站域名：</label>
                <input type="text" name="siteDomain" placeholder="网站域名" v-model="search.param.siteDomain">
              </div>
              <div class="input">
                <label>主体名称：</label>
                <input type="text" name="companyName" placeholder="主体名称" v-model="search.param.companyName">
              </div>
              <div class="input">
                <label>统一社会信用代码：</label>
                <input type="text" name="companyNumber" placeholder="统一社会信用代码" v-model="search.param.companyNumber">
              </div>
              <p class="query-form-remark">注：输入任意一项即可查询</p>
              <div class="query-form-btn" @click="dataList" style="cursor: pointer">查 询</div>
            </form>
          </div>
          <div class="bs-table">
            <table class="table" cellpadding="0" cellspacing="0" border="0">
              <thead>
              <tr>
                <th>状态</th>
                <th style="border-left:1px solid #bcdeed;">企业类型</th>
                <th style="border-left:1px solid #bcdeed;">企业名称</th>
                <th style="border-left:1px solid #bcdeed;">域名</th>
                <th style="border-left:1px solid #bcdeed;">请求时间</th>
              </tr>
              </thead>
              <tbody>
              <tr class="table-bg" v-for="(item,index) in list"
                  :style="index%2 === 0? 'background-color:#F6F9FA' : 'background-color:white'">
                <td>{{
                    item.applyStatusStr
                  }}
                </td>
                <td>{{
                    item.companyTypeStr
                  }}
                </td>
                <td>{{
                    item.companyName
                  }}
                </td>
                <td>
                  <li style="background:rgba(0,0,0,0) none repeat scroll !important;" v-for="domain in item.domainItems"
                      class="s-urlItems">{{ domain }}
                  </li>
                </td>
                <td>
                  {{ item.createTime }}
                </td>
              </tr>
              </tbody>
            </table>
            <el-pagination
              style="float: right"
              background
              layout="prev, pager, next"
              :total="search.page.total"
              :page.sync="search.page.current"
              :page-size.sync="search.page.size"
              @current-change="changePage($event)"
            >
            </el-pagination>
            <!--  <pagination
                :total="search.page.total"
                :page.sync="search.page.current"
                :page-size.sync="search.page.size"
                @pagination="dataList"/>-->
          </div>
        </div>
        <div class="bs-right">
          <div class="bs-userLogin">
            <div class="bs-title">用户登录</div>
            <div class="userlogin" v-if="isLogin" id="userDiv">
              <div class="userInfo">
                <el-tooltip class="item" effect="dark" content="编辑信息" placement="top-start">
                  <router-link :to="{path:'/updateUserInfo'}"><span class="user-icon" id="user-icon"
                                                                    data-container="body"
                                                                    data-toggle="popover"
                                                                    data-trigger="hover"
                                                                    data-placement="top"
                                                                    data-content="编辑信息！"></span></router-link>
                </el-tooltip>
                <span title="" class="user-name" id="loginName">{{ userInfo.userName }}</span>
                <span class="user-line"></span> <span class="user-exit" @click="logout">退出</span>
              </div>
              <router-link :to="{path:'/signApply'}" style="text-decoration:none;">
                <div class="apply-btn">
                  <span class="apply-icon"></span>亮照申请
                </div>
              </router-link>
              <router-link :to="{path:'/mySitePage'}"
                           style="text-decoration:none;">
                <div class="apply-btn">
                  <span class="bright-icon"></span>我的亮照
                </div>
              </router-link>
              <router-link :to="{path:'/updateUserInfo'}" style="text-decoration:none;">
                <div class="bright-btn">
                  <span class="apply-icon"></span>编辑信息
                </div>
              </router-link>
            </div>

            <div class="userout" id="loginDiv" v-if="!isLogin">
              <form method="post" id="loginForm">
                <div class="userout-list" style="margin-bottom:-10px;">
                  <input id="loginUserName" type="text" placeholder="请输入用户名/邮箱" name="name"
                         v-model="loginInfo.userName">
                  <input type="password" placeholder="请输入密码" id="password" name="pwd" v-model="loginInfo.password">
                  <div id="KaptchaDiv" style="display: none;position:relative">
                    <input type="text" placeholder="请输入验证码" id="KaptchaCode" name="kaptcha"
                           style="padding-right:110px;">
                  </div>
                  <div class="ar-items" style="position:relative;">
                    <el-input type="text"  placeholder="请输入验证码" id="verCode" v-model="loginInfo.verCode" name="verCode" @keyup.enter.native="userLogin()"/>
                    <img id="kaptcha" @click="kaptchaClick" :src="kaptchaUrl" style="width:100px; height:34px; position: absolute; left:136px; top:0px; border:1px solid #d2d6de;cursor:pointer;" alt="验证码"/>
                  </div>
                </div>
                <p id="lgs_error" class="lgsErr"></p>
                <div class="userout-btn" @click="userLogin()">登录</div>
              </form>
              <div class="userout-alert">
                <router-link :to="{path:'/resetPassword'}"> 忘记密码？</router-link>
                没有账号，请先进行
                <router-link
                  :to="{path:'/signApply'}">注册
                </router-link>
              </div>
            </div>
          </div>
          <div class="bs-newList">
            <div class="bs-title">亮照申请用户</div>
            <!--   <ul class="news-list">
                 <li class="new-items">${siteBaseInfo.companyName}</li>
               </ul>-->
            <div class="user-commit">
              <vue-seamless-scroll :data="nearMonthList" :class-option="classOption" class="commit-scroll">
                <ul>
                  <li v-for="(item,index) in nearMonthList" :key="index">
                    <span class="user-commit-item"><i icon="el-icon-s-opportunity"/>{{
                        item.length > 13 ? (item.substr(0, 12) + '...') : item
                      }}</span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'
import {encryption} from '../assets/js/utils'
export default {
  name: 'allSitePage',
  components: {
    'navigation': navigation
  },
  data() {
    return {
      kaptchaUrl: this.config.kaptchaUrl,
      isLogin: false, // 是否登录
      search: { // 分页查询参数
        param: {
          companyNumber: null, // 同意社会信用代码
          siteDomain: null, // 网站域名
          companyName: null // 企业名称
        },
        page: {
          total: 0,
          current: 1,
          size: 10
        }
      },
      list: [], // 公示信息列表
      nearMonthList: [], // 最近一个月数据
      loginInfo: { // 登录接口参数
        userName: null,
        password: null,
        verCode: null
      }, userInfo: { // 用户信息
        userName: '',
        password: null
      }
    }
  }, computed: {
    classOption() {
      return {
        limitMoveNum: 2,
        hoverStop: true,
        direction: 1,
        autoPlay: true,
        singleHeight: 57,
        waitTime: 0,
        step: 0.5,
      }
    }
  },
  watch: {
    $route: function (route) {
      this.dataList(this, 1)
    }
  },
  created: function () {
    if (this.$route.query.companyName != null && this.$route.query.companyName !== 'null') {
      this.search.param.companyName = this.$route.query.companyName
    }
    if (this.$route.query.companyNumber != null && this.$route.query.companyNumber !== 'null') {
      this.search.param.companyNumber = this.$route.query.companyNumber
    }
    if (this.$route.query.siteDomain != null && this.$route.query.siteDomain !== 'null') {
      this.search.param.siteDomain = this.$route.query.siteDomain
    }
    this.getUserInfo()
    this.loadMore()
    this.$nextTick(()=>{
      this.kaptchaClick()
    });
    this.selectNearMonth()
  },
  methods: {
    kaptchaClick() {
      var img = document.getElementById("kaptcha");
      img.setAttribute("src", this.kaptchaUrl);
    },
    getUserInfo() {
      let _self = this
      _self.axios.get(
        _self.api.getUserInfo
      ).then(res => {
        if (res.data.code === 10000) {
          this.isLogin = true
          this.userInfo = res.data.obj
        } else {
          this.isLogin = false
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    changePage(value) {
      this.search.page.current = value
      this.dataList(this)
    }, loadMore() {
      this.dataList(this)
    },
    dataList() {
      let _self = this
      _self.axios.post(
        _self.api.allSitePage, this.search,
      ).then(results => {
        this.search.page.total = results.data.obj.total
        this.list = results.data.obj.records
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    /**
     * 查询最近一个月数据
     */
    selectNearMonth() {
      let _self = this
      _self.axios.get(
        _self.api.selectNearMonth,
      ).then(results => {
        this.nearMonthList = results.data.obj
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    /**
     * 用户登录
     */
    userLogin() {
      let _self = this
      if (this.loginInfo.userName == null || this.loginInfo.userName === '') {
        this.$message.warning('请填写用户名')
        return
      }
      if (this.loginInfo.password == null || this.loginInfo.password === '') {
        this.$message.warning('请填写密码')
        return
      }
      if (this.loginInfo.verCode == null || this.loginInfo.verCode == '') {
        this.$message.warning('请输入验证码')
        return
      }
      const logData = {
        password: encryption(this.loginInfo.password, _self.api.aesKey),
        userName: this.loginInfo.userName,
        verCode: this.loginInfo.verCode
      }
      _self.axios.post(_self.api.login, logData).then(res => {
        if (res.data.code === 10000) {
          this.userInfo = res.data.obj
          this.userInfo.password = null
          this.isLogin = true
        } else {
          this.$message.error(res.data.message)
          this.kaptchaClick()
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    /**
     *  用户退出
     */
    logout() {
      let _self = this
      _self.axios.get(_self.api.logout).then(res => {
        //  this.$message.success('退出成功!')
        this.isLogin = false
      }).catch(err => {
        this.$message.error(_self.config.ERRORMESSAGE)
      })
    }
  }
}
</script>

<style>
@import '../assets/css/newStyle.css';
@import '../assets/css/bright.css';

.query-form {
  padding-top: 0px;
}

table tr:nth-child(even) {

  background: #ccc;

}
</style>




// WEBPACK FOOTER //
// src/components/allSitePage.vue